import React from 'react';
import ScheduledImportsList from '../components/imports/ScheduledImportsList';
import ImportHistory from '../components/imports/ImportHistory';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

const ScheduledImportsPage = () => {
  const { currentUser } = useAuth();

  // Vérifier que l'utilisateur est admin ou admin_assistant
  if (!currentUser || (currentUser.role !== 'admin' && currentUser.role !== 'admin_assistant')) {
    return <Navigate to="/access-denied" />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* En-tête de la page */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">
            Gestion des Importations
          </h1>
          <p className="mt-2 text-gray-600">
            Configurez et surveillez vos importations automatiques de données
          </p>
        </div>

        {/* Section des importations programmées */}
        <div className="mb-8">
          <div className="bg-white shadow rounded-lg">
            <div className="px-6 py-4 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-gray-900">
                Importations Programmées
              </h2>
            </div>
            <div className="p-6">
              <ScheduledImportsList />
            </div>
          </div>
        </div>

        {/* Section de l'historique des importations */}
        <div className="mb-8">
          <div className="bg-white shadow rounded-lg overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-gray-900">
                Historique des Importations
              </h2>
              <p className="mt-1 text-sm text-gray-600">
                Consultez l'historique complet de toutes vos importations
              </p>
            </div>
            {/* Container avec scroll horizontal pour éviter le débordement */}
            <div className="overflow-x-auto">
              <ImportHistory />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduledImportsPage;